<template>
  <div class="option-blocage">
    <div class="option-blocage-content">
      <div
        v-for="(item, index) in mapAffectations"
        :key="`aff-${index}`"
        class="media is-align-items-center p-5">
        <div class="media-left">
          <div :class="`square ${item.classEtatAff}`"></div>
        </div>
        <div class="media-content">
          <h4 class="has-text-link is-size-14px has-text-weight-bold mb-1">
            {{item.libelle}}
          </h4>
          <p class="is-size-7 has-text-default">
            {{item.nbFaces}} faces</p>
        </div>
        <div class="media-rigth is-size-7 has-text-default">
          {{item.referenceCode}}
        </div>
      </div>
      <div
        v-if="totalFacesNoAff"
        class="media is-align-items-center p-5">
        <div class="media-left">
          <div class="square libre"></div>
        </div>
        <div class="media-content">
          <h4 class="has-text-link is-size-14px has-text-weight-bold mb-1">
            Disponible
          </h4>
          <p class="is-size-7 has-text-default">
            {{totalFacesNoAff}} faces</p>
        </div>
      </div>
    </div>
    <div class="is-flex is-align-items-center">
      <div
        v-for="(item, index) in listeOptionsBlocage"
        :key="`opt-${index}`"
        class="level mb-0">
        <div class="level-left">
          <div :class="`leve-item mr-2 square ${item.class}`"/>
          <div class="leve-item">
            {{item.name}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  TYPE_DEVIS,
  EN_ATTENTE_RELANCE_OPTION,
  RELANCE_OPTION,
  ETAT_FACTURE,
  ETAT_FACTURE_PARTIELLEMENT,
  BLOQUE,
  OPTION,
} from '@/configuration/devisConf';

export default {
  props: {
    affectations: Array,
    totalFaces: Number,
  },
  data() {
    return {
      listeOptionsBlocage: [
        {
          name: 'Bloqué en commande',
          class: 'bloque-en-commande',
        },
        {
          name: 'Bloqué en Devis',
          class: 'bloque-en-devis',
        },
        {
          name: 'Option',
          class: 'en-option',
        },
        {
          name: 'Relance d’option',
          class: 'en-relance-option',
        },
        {
          name: 'Facturé',
          class: 'facture',
        },
        {
          name: 'Libre',
          class: 'libre',
        },
      ],
    };
  },
  computed: {
    mapAffectations() {
      if (!this.affectations) return [];
      return this.affectations.map(aff => ({
        libelle: aff.libelle,
        nbFaces: aff.nbFaces,
        referenceCode: aff.referenceCode,
        classEtatAff: this.getClassEtatAff(aff),
      }));
    },
    totalFacesNoAff() {
      let nbFacesAff = 0;
      if (!!this.affectations && this.affectations.length) {
        nbFacesAff = this.mapAffectations
          .filter(aff => aff.classEtatAff !== 'en-relance-option')
          .reduce((acc, val) => acc + val.nbFaces, 0);
      }
      return this.totalFaces - nbFacesAff;
    },
  },
  methods: {
    getClassEtatAff(affectation) {
      if (affectation.referenceType === TYPE_DEVIS && affectation.etatObtenu === BLOQUE) {
        return 'bloque-en-devis';
      }
      if (affectation.referenceType === TYPE_DEVIS
        && (affectation.etatObtenu === EN_ATTENTE_RELANCE_OPTION
          || affectation.etatObtenu === RELANCE_OPTION)) {
        return 'en-relance-option';
      }
      if (affectation.referenceType === TYPE_DEVIS && affectation.etatObtenu === OPTION) {
        return 'en-option';
      }
      if ((affectation.referenceEtat === ETAT_FACTURE
        || affectation.referenceEtat === ETAT_FACTURE_PARTIELLEMENT)
        && affectation.etatObtenu === BLOQUE) {
        return 'facture';
      }
      return 'bloque-en-commande';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/creationOpportunite/panier/composantsProduits/venteReseauxTempo/consultation/OptionBlocage.vue